import { render, staticRenderFns } from "./MyWebinarItem.vue?vue&type=template&id=676bd770&scoped=true"
import script from "./MyWebinarItem.vue?vue&type=script&lang=js"
export * from "./MyWebinarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676bd770",
  null
  
)

export default component.exports